export default "__VITE_ASSET__fcda0d54__"